import styled from 'styled-components';


export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    height: fit-content;
    background: ${({ theme }) => theme.colors.interfacePure0};
    border-radius: 8px;
    padding: 24px;

    span {
        font-size: 14px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.interfaceGray400};
    }

    .number-cards {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
        overflow: hidden;

        .card {
            display: flex;
            flex-direction: column;
            gap: 8px;
            width: 104px;
            height: 69px;
            border-radius: 8px;
            padding: 8px;

            .top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 24px;
                font-weight: 400;
            }

            span {
                font-size: 14px;
                font-weight: 600;
                color: ${({ theme }) => theme.colors.interfaceText400};
            }

            &.resolved {
                background-color: ${({ theme }) => theme.colors.interfaceSuccess100};
                .top {
                    color: ${({ theme }) => theme.colors.interfaceSuccess400};
                    svg {
                        width: 12px;
                        path {
                            fill: ${({ theme }) => theme.colors.interfaceSuccess400};
                        }
                    }
                }
            }
            &.accept {
                background-color: ${({ theme }) => theme.colors.secondaryGreen050};
                .top {
                    color: ${({ theme }) => theme.colors.secondaryGreen600};
                    svg {
                        width: 12px;
                        path {
                            fill: ${({ theme }) => theme.colors.secondaryGreen600};
                        }
                    }
                }
            }
            &.refused {
                background-color: ${({ theme }) => theme.colors.interfaceDanger100};
                .top {
                    color: ${({ theme }) => theme.colors.interfaceDanger400};
                    svg {
                        path {
                            fill: ${({ theme }) => theme.colors.interfaceDanger400};
                        }
                    }
                }
            }
            &.waiting {
                background-color: ${({ theme }) => theme.colors.primaryOrange50};
                .top {
                    color: ${({ theme }) => theme.colors.primaryOrange700};
                    svg {
                        width: 12px;
                        path {
                            fill: ${({ theme }) => theme.colors.primaryOrange700};
                        }
                    }
                }
            }
            &.response {
                background-color: ${({ theme }) => theme.colors.secondaryPool100};
                .top {
                    color: ${({ theme }) => theme.colors.primaryBlue100};
                    svg {
                        path {
                            fill: ${({ theme }) => theme.colors.primaryBlue100};
                        }
                    }
                }

                span {
                    color: ${({ theme }) => theme.colors.primaryBlue500};
                }
            }
        }
        
        .arrow {
            cursor: pointer;
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.interfaceTextGray};
                }
            }
        }
        @media (max-width: 420px) {
            gap: 8px;
            .card { width: calc(50% - 8px); min-width: 140px; }
        }
    }

    .documentation {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        padding: 16px;
        border: 1px solid ${({ theme }) => theme.colors.interfaceText100};
        border-radius: 8px;

        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .icon-title {
                display: flex;
                align-items: center;
                gap: 10px;
                color: ${({ theme }) => theme.colors.interfaceGray400};
                font-size: 14px;
                font-weight: 500;
            }

            .status {
                display: flex;
                align-items: center;
                gap: 10px;
                width: fit-content;
                height: 32px;
                padding: 5px 8px;
                border-radius: 8px;
                color: ${({ theme }) => theme.colors.interfaceText400};
                font-size: 14px;
                font-weight: 600;

                &.success {
                    background: ${({ theme }) => theme.colors.interfaceSuccess100};
                }

                &.refuse {
                    background: ${({ theme }) => theme.colors.interfaceDanger100};
                }

                svg {
                    width: 12px;
                    height: 12px;
                    path {
                        fill: ${({ theme }) => theme.colors.interfaceText400};
                    }
                }
            }
        }

        .list {
            
            p {
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                color: ${({ theme }) => theme.colors.interfaceText400};
                
                &::before {
                    content: "•";
                    color: ${({ theme }) => theme.colors.interfaceText400};
                    font-weight: bold;
                    display: inline-block; 
                    width: 1em;
                    margin-left: 0;
                }
            }

        }
    }

    .instruction {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        padding: 16px;
        border: 1px solid ${({ theme }) => theme.colors.interfaceText100};
        border-radius: 8px;

        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .icon-title {
                display: flex;
                align-items: center;
                gap: 10px;
                color: ${({ theme }) => theme.colors.interfaceGray400};
                font-size: 14px;
                font-weight: 500;
            }

            .status {
                display: flex;
                align-items: center;
                gap: 10px;
                width: fit-content;
                height: 32px;
                padding: 5px 8px;
                border-radius: 8px;
                color: ${({ theme }) => theme.colors.interfaceText400};
                font-size: 14px;
                font-weight: 600;

                &.success {
                    background: ${({ theme }) => theme.colors.interfaceSuccess100};
                }

                &.refuse {
                    background: ${({ theme }) => theme.colors.interfaceDanger100};
                }

                svg {
                    width: 12px;
                    height: 12px;
                    path {
                        fill: ${({ theme }) => theme.colors.interfaceText400};
                    }
                }
            }
        }

        p {
            color: ${({ theme }) => theme.colors.interfaceText400};
            font-size: 14px;
            font-weight: 400;
        }
    }

    .add {
        display: flex;
        align-items: center;
        gap: 20px;
        height: 56px;
        padding: 16px;
        border: 2px dotted ${({ theme }) => theme.colors.primaryRed400};
        border-radius: 8px;
        color: ${({ theme }) => theme.colors.interfaceGray400};
        font-weight: 500;
        cursor: pointer;
        svg {
            path {
                fill: ${({ theme }) => theme.colors.primaryRed400};
            }
        }
    }

    .empty {
        font-weight: 400;
        color: ${({ theme }) => theme.colors.interfaceText500};
    }
`

export const Pendency = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    padding: 16px;
    border: 1px solid ${({ theme }) => theme.colors.interfaceText100};
    border-radius: 8px;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon-title {
            display: flex;
            align-items: center;
            gap: 10px;
            color: ${({ theme }) => theme.colors.interfaceGray400};
            font-size: 14px;
            font-weight: 500;
        }

        .date-status {
            display: flex;
            align-items: center;
            gap: 16px;

            .date {
               font-size: 14px;
               font-weight: 400;
               color: ${({ theme }) => theme.colors.interfaceText300};
            }
        }

        .status {
            display: flex;
            align-items: center;
            gap: 10px;
            width: fit-content;
            height: 32px;
            padding: 5px 8px;
            border-radius: 8px;
            color: ${({ theme }) => theme.colors.interfaceText400};
            font-size: 14px;
            font-weight: 600;

            &.success {
                background: ${({ theme }) => theme.colors.interfaceSuccess100};
            }

            &.refuse {
                background: ${({ theme }) => theme.colors.interfaceDanger100};

                svg {
                    width: 16px;
                    height: 16px;
                    path {
                        fill: ${({ theme }) => theme.colors.interfaceText400};
                    }
                }
            }

            &.resolve {
                background: ${({ theme }) => theme.colors.interfaceGray400};
                color: ${({ theme }) => theme.colors.interfacePure0};
                cursor: pointer;
            }

            &.waiting {
                background: ${({ theme }) => theme.colors.primaryOrange50};
                color: ${({ theme }) => theme.colors.interfacetext400};                
            }

            svg {
                width: 12px;
                height: 12px;
                path {
                    fill: ${({ theme }) => theme.colors.interfaceText400};
                }
            }
        }

        .status-link {
            display: flex;
            align-items: center;
            gap: 16px;

            .button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 32px;
                height: 32px;
                background-color: ${({ theme }) => theme.colors.background};
                border-radius: 8px;
                cursor: pointer;
            }
        }
        
    }

    .money {
        color: ${({ theme }) => theme.colors.interfaceGray500};
        font-size: 14px;
        font-weight: 500;

        span {
            color: ${({ theme }) => theme.colors.interfaceText300};
            font-size: 14px;
            font-weight: 500;
            margin-left: 16px;
        }
    }

    .info {
        color: ${({ theme }) => theme.colors.interfaceText400};
        font-size: 14px;
        font-weight: 400;

    }  
    
    .list {
        display: flex;
        flex-direction: column;
        gap: 24px;        

        p {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: ${({ theme }) => theme.colors.interfaceText400};
        }

        .answer {
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding-left: 30px;

            .title {
                color: ${({ theme }) => theme.colors.interfaceText400};
                font-size: 14px;
                font-weight: 500;
            }
        }

    }
`